// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"161":"96892fc9","198":"629506b5","404":"2fd1372e","709":"fc33318a"}[chunkId] + ".chunk.js";
};